/* eslint-disable prettier/prettier */
export default class AdwordsYoutube {
    constructor(context) {
            this.context = context;
            this.axios = this.context.$axios;
        }
        // BUMPER
    async getMetricsVideo(
        subscriberId,
        businessUnitId,
        fromDate,
        toDate,
        customerId,
        VIDEO_TYPE
    ) {
        try {
            
            let VideoCode = null;

            if (VIDEO_TYPE == 1) {
                VideoCode = "VBP";
            }else if (VIDEO_TYPE == 2) {
                VideoCode = "VSP";
            }else if (VIDEO_TYPE == 3) {
                VideoCode = "VDC";
            } else if (VIDEO_TYPE == 4) {
                VideoCode = "VNSP";
            } else if (VIDEO_TYPE == 5) {
                VideoCode = "VAC";
            }

            const metricsVideo = await this.axios.get(
                `${
          process.env.VUE_APP_API_BASE_URL_GOOGLE
        }/Adwords/videos/${VIDEO_TYPE}/${customerId}/businesses/${businessUnitId}/${
            VideoCode
        }?fromDate=${fromDate}&toDate=${toDate}`
            );
            return {
                ...metricsVideo.data
            };
        } catch (err) {
            console.log(`Fallo la peticion:${err}`);
        }
    }
}